import { gql } from '@apollo/client';

import brokerPublicFragment from '../fragments/brokerPublicFragment';

export default gql`
  query getBrokerByCode($code: String!) {
    getBrokerByCode(code: $code) {
      ...brokerPublicFragment
    }
  }
  ${brokerPublicFragment}
`;
